import React, { useCallback, useContext, useState,useEffect,useMemo } from "react";
import { ModalNextContext } from '@jutro/components';
import { ViewModelServiceContext,ViewModelForm,useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, IntlContext ,useTranslator } from '@jutro/locale';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { LoaderExt } from 'gw-components-platform-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import _, { random } from "lodash";
import PropTypes from 'prop-types';
// import PayrollService from "../../../capabilities/cpmi-capability-payroll/services/PayrollService";
import metadata from "./CPMIClassCodeComponent.metadata.json5";
import styles from "./CPMIClassCodeComponent.module.scss";
import messages from "./CPMIClassCodeComponent.messages";
import PayrollInvoiceTable from "../../PayrollReview/PayrollInvoiceTable/PayrollInvoiceTable";

import { Link } from '@jutro/router';

function CPMIClassCodeComponent(props) {
    const ModalNext=useContext(ModalNextContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const { refreshData } = useDataRefresh()
    const [randomNumber,setrandomNumber]=useState(0);
    const [payrollVM,setPayrollVM] = useState(props.data);
    const {id,onCallback}=props;
    const {blankValues}=props;
    const [arrayVisible,setVisible]=useState([]);
    const [sortedData,setSortedData] = useState();

    // Juridiction grouping totals for state
    const result = [];
        
    const holder = {};

    const customSort =(obja, objb) => {
            const a = obja.classCode.code;
            const b = objb.classCode.code;
            for (let i = 0; i < Math.min(a.length, b.length); i++) {
                const charA = a.charAt(i);
                const charB = b.charAt(i);


                const isCharA = /[a-zA-Z]/.test(charA);
                const isCharB = /[a-zA-Z]/.test(charB);

                if (isCharA && !isCharB) {
                    return -1;
                } else if (!isCharA && isCharB) {
                    return 1;
                } else if (isCharA && isCharB) {

                    if (charA < charB) return -1;
                    if (charA > charB) return 1;
                } else {

                    if (parseInt(charA) < parseInt(charB)) return -1;
                    if (parseInt(charA) > parseInt(charB)) return 1;
                }
            }


            return a.length - b.length;
        };

    useEffect(()=>{        
        props.data.sort((a, b)=> {
            const createSortKey = (p)=> { return `${p.location.locationName_Ext}`}
            if(createSortKey(a) === createSortKey(b)){
                return customSort(a,b);
            }
            return createSortKey(a) > createSortKey(b) ? 1 : -1
        })
        props.data.forEach((d) => {
            if((d.empLocation.locationCode !== undefined && d.empLocation.locationCode !== "") && (d.empLocation.locationName_Ext !=="" || d.empLocation.locationName_Ext !==undefined)){
                // eslint-disable-next-line operator-assignment
                d.empLocation.locationCode = `${d.empLocation.locationCode  } ${  d.empLocation.locationName_Ext}`
            }

            if(d.empLocation.locationCode === undefined || d.empLocation.locationCode===""){
                d.empLocation.locationCode = d.empLocation.locationName.split(':')[1].trim();  
            }
        }); 

    },[props.data])

    
    

    

    props.data.forEach((d) => {
        if (holder.hasOwnProperty(d.governingDescription)) {
            // eslint-disable-next-line operator-assignment
            holder[d.governingDescription] = holder[d.governingDescription] + (d?.auditedEmployeeCount?d?.auditedEmployeeCount:0);
        } else {
            holder[d.governingDescription] = (d?.auditedEmployeeCount?d?.auditedEmployeeCount:0);
        }
    });

    const obj2 = [];

    // eslint-disable-next-line guard-for-in
    for (const prop in holder) {
        obj2.push({ name: prop, value: holder[prop] });
    }
    result.push(obj2);

    props.data.forEach((element) => {
        for(const u in result[0]){
            if(element.governingDescription ===result[0][u].name){
                element.employCountJuriduction = result[0][u].value;
            }
        }
        
    });


    const auditedPayrollAmountHolder = {};
    props.data.forEach((d) => {
        if (auditedPayrollAmountHolder.hasOwnProperty(d.governingDescription)) {
            // eslint-disable-next-line operator-assignment
            auditedPayrollAmountHolder[d.governingDescription] = auditedPayrollAmountHolder[d.governingDescription] + (d?.auditedPayrollAmount?d?.auditedPayrollAmount:0);
        } else {
            auditedPayrollAmountHolder[d.governingDescription] = (d?.auditedPayrollAmount?d?.auditedPayrollAmount:0);
        }
    });
    const auditedPayrollAmountResult = [];

    const auditedPayrollAmountObj2 = [];

    // eslint-disable-next-line guard-for-in
    for (const prop in auditedPayrollAmountHolder) {
        auditedPayrollAmountObj2.push({ name: prop, value: auditedPayrollAmountHolder[prop] });
    }
    auditedPayrollAmountResult.push(auditedPayrollAmountObj2);

    props.data.forEach((element) => {
        for(const u in auditedPayrollAmountResult[0]){
            if(element.governingDescription ===auditedPayrollAmountResult[0][u].name){
                element.auditedPayrollAmountJuriduction = auditedPayrollAmountResult[0][u].value;
            }
        }
        
    });

    // Juridiction grouping totals for state


    // location Grouping for state
    const resultAuditedEmployeeCount = [];
        
    const holderAuditedEmployeeCount = {};

    props.data.forEach((d) => {
        if (holderAuditedEmployeeCount.hasOwnProperty(d.empLocation.locationCode)) {
            // eslint-disable-next-line operator-assignment
            holderAuditedEmployeeCount[d.empLocation.locationCode] = parseInt(holderAuditedEmployeeCount[d.empLocation.locationCode]) + parseInt((d?.auditedEmployeeCount?d?.auditedEmployeeCount:0));
        } else {
            holderAuditedEmployeeCount[d.empLocation.locationCode] = parseInt((d?.auditedEmployeeCount?d?.auditedEmployeeCount:0));
        }
    });

    const obj2AuditedEmployeeCount = [];

    // eslint-disable-next-line guard-for-in
    for (const prop in holderAuditedEmployeeCount) {
        obj2AuditedEmployeeCount.push({ name: prop, value: holderAuditedEmployeeCount[prop] });
    }
    resultAuditedEmployeeCount.push(obj2AuditedEmployeeCount);

    props.data.forEach((element) => {
        for(const u in resultAuditedEmployeeCount[0]){
            if(element.empLocation.locationCode ===resultAuditedEmployeeCount[0][u].name){
                element.employCountLocation = resultAuditedEmployeeCount[0][u].value || '0';
            }
        }
        
    });

    

    const resultauditedPayrollAmountLocation = [];
        
    const holderauditedPayrollAmountLocation = {};
    const tempAry = [];
    props.data.forEach((d) => {
        if (holderauditedPayrollAmountLocation.hasOwnProperty(d.empLocation.locationCode)) {
            // eslint-disable-next-line operator-assignment
            holderauditedPayrollAmountLocation[d.empLocation.locationCode] = parseInt(holderauditedPayrollAmountLocation[d.empLocation.locationCode]) + parseInt((d?.auditedPayrollAmount?d?.auditedPayrollAmount:0));
            tempAry.push({isVisible:true});
        } else {
            holderauditedPayrollAmountLocation[d.empLocation.locationCode] = parseInt((d?.auditedPayrollAmount?d?.auditedPayrollAmount:0));
            tempAry.push({isVisible:false});
        }
    });


    const obj2auditedPayrollAmountLocation = [];
    const temparryShowhide =[];
    // eslint-disable-next-line guard-for-in
    for (const prop in holderauditedPayrollAmountLocation) {
        obj2auditedPayrollAmountLocation.push({ name: prop, value: holderauditedPayrollAmountLocation[prop] });
    }
    resultauditedPayrollAmountLocation.push(obj2auditedPayrollAmountLocation);
    
    props.data.forEach((element) => {
        for(const u in resultauditedPayrollAmountLocation[0]){
            if(element.empLocation.locationCode ===resultauditedPayrollAmountLocation[0][u].name){  
                const lIndex = temparryShowhide.findIndex((i) => i?.empLocation === element.empLocation.locationCode && i?.isVisible === true)
                const temopObj = { empLocation: element.empLocation.locationCode, isVisible: true }
                if (lIndex === -1) {
                    temparryShowhide.push(temopObj);
                } else {
                    temparryShowhide[lIndex].isVisible = false
                    temparryShowhide.push(temopObj);
                }
                element.auditedPayrollAmountLocation = resultauditedPayrollAmountLocation[0][u].value || '0';
                 
            }
        }
        
    });

    if(!_.isEqual(temparryShowhide,arrayVisible)){
        setVisible(temparryShowhide);
    }
    
    // location Grouping for state
    
    useEffect(()=>{
        if(blankValues===true){
            payrollVM.forEach((item)=>{
                if(item.auditedEmployeeCount===undefined || item.auditedEmployeeCount===""){
                    item.auditedEmployeeCount="0"
                }
                if(item.auditedPayrollAmount===undefined || item.auditedPayrollAmount===""){
                    item.auditedPayrollAmount="0"
                }
            })
        }
        setPayrollVM(payrollVM)
        onCallback(id,payrollVM)
        refreshData();
    },[blankValues, id, onCallback, payrollVM])

    useEffect(() => {

        payrollVM.forEach((item) => {
            if (item.auditedEmployeeCount === 0) {
                item.auditedEmployeeCount = "0"
            }
            if (item.auditedPayrollAmount === 0) {
                item.auditedPayrollAmount = "0"
            }
        })
        setPayrollVM(payrollVM)
        onCallback(id, payrollVM)
        refreshData();
    }, [])
    

    const writeValue = useCallback(
        (value, path) => {
            if(value==="."){
                return 
            }
            if (!_.isNaN(parseInt(value))) {
                value = parseInt(value)
                if(value===0){
                    value="0"
                }
            }
            if(props.location.state.appValue==='CE')
            {
                path = path.split('.');
                _.set(payrollVM,`[${path[0]}].${path[1]}`, value);

            }
            else{
                path = path.split(/(\d+)/)
            
                _.set(payrollVM,`[${path[1]}]${path[2]}`, value);

            }
        
            
            setPayrollVM(payrollVM)
            onCallback(id,payrollVM)
            refreshData();
        },
        [id, onCallback, payrollVM, props, refreshData]
    );

    const renderDescription =(item)=>{
        let desc  = ''
        if(item.governingLaw === "state"){
            desc ="State Act"
        }else if(item.governingLaw === "longshoreAndHarbor"){
            desc ="USL&H"
        }else if(item.governingLaw === "admiraltyLaw"){
            desc ="Admiralty Law"
        }else if(item.governingLaw === "FELA"){
            desc ="FELA"
        }

        return desc;
    }


    const generateOverrides = useMemo(() => {
        
        const overrides=payrollVM.map((item,index)=>{
           
            return{
                [`locationdata${index}`]: {
                    value: item.location.locationName_Ext//_.get(payrollVM,`${index}.empLocation.locationName`).split(':')[1],
                },
                [`StateGrossAmount${index}`]: {
                    visible: arrayVisible[index]?.isVisible??true
                },
                [`juridictionId${index}`]: {
                    value: renderDescription(item)
                },
                [`classcodedata${index}`]: {
                    content: item.classCode.classification
                },

                // [`stateempcountdata${index}`]: {
                //     value: item.employCountLocation===0?'0':item.employCountLocation
                // },

                
                
                
            }
        })
        return Object.assign({}, ...overrides);
    }, [arrayVisible, payrollVM]);

    
    const overrides = {
        ClassCodeDetails:{
            data:payrollVM
        },
        ...generateOverrides

    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {

        },
        resolveComponentMap:{
        }
    };

    return  <ViewModelForm
        uiProps={metadata.pageContent}
        model={payrollVM}
        overrideProps={overrides}
        onValueChange={writeValue}
        componentMap={resolvers.resolveComponentMap}
        classNameMap={resolvers.resolveClassNameMap}
        callbackMap={resolvers.resolveCallbackMap}
    />
}

CPMIClassCodeComponent.defaultProps = {
    onCallback: PropTypes.func.isRequired,
};
export default withRouter(CPMIClassCodeComponent);